<template>
  <div class="flex flex-row items-start justify-between">
    <img :src="statusIcon" class="bg-grey-extralight h-6 w-6 p-1 rounded-full mr-3" style="z-index: 2" />
    <div class="flex flex-col w-full font-semibold justify-center pl-5 pb-4" :class="itemPosition === 'last' ? '' : 'border-l-2 border-dashed'" style="margin-left: -1.55rem;margin-top: -1px;">
      <div class="flex flex-row text-base items-center justify-between" style="margin-top: -0.215rem">
        <div class="leading-loose">{{activity.title}}<span v-show="activity.type === 'Challenge'"> ({{activity.name}})</span></div>
        <a v-show="activity.type === 'Consultation' && activity.prescription_url" target="_blank" :href="activity.prescription_url" class="text-blue hover:no-underline cursor-pointer">Prescription</a>
      </div>
      <div>
        <div class="text-sm text-grey" :class="summary ? 'summary' : ''" v-if="activity.type === 'Consultation'" v-html="statusText()"></div>
        <div v-else class="text-sm text-grey">{{statusText()}}</div>
      </div>
      <div v-show="activity.type === 'Challenge' && ['new', 'pending', 'completed'].includes(activity.status)" class="text-sm text-grey leading-tight">
        <div v-if="activity.status === 'completed'">
          <p>Started the Challenge</p>
          <ul style="margin-left: -1rem">
            <li>Challenge progress: {{activity.progress}}</li>
            <li>Days Taken: {{activity.days_utilized}} consecutive days</li>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="showArrowIcon" class="h-5 w-5 bg-grey-extralight rounded-full">
      <img @click="toggleView" class="h-3 m-1 cursor-pointer stroke-current text-grey-darkest" src="../../assets/forward arrow.svg" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      summary: true
    }
  },
  props: {
    activity: Object,
    showHraAndTests: Boolean,
    week: String,
    itemPosition: String,
    startDate: String,
    currentWeek: String
  },
  computed: {
    overdueDays: function () {
      let startDate = new Date(this.startDate)
      let date = new Date()
      let diffTime = date.getTime() - startDate.getTime()
      let diffDays = diffTime / (1000 * 3600 * 24)
      return Math.floor(diffDays)
    },
    statusIcon: function () {
      if (this.activity.status === 'overdue') return require('../../assets/inprogress.svg')
      if (this.activity.status === 'pending' || this.activity.status === 'scheduled') return require('../../assets/orange_ring.svg')
      if (this.activity.status === 'completed') return require('../../assets/tick_green_outline.svg')
      if (this.activity.status === 'new') return require('../../assets/grey_circle.svg')
    },
    showArrowIcon: function () {
      if (['Consultation', 'Challenge'].includes(this.activity.type)) return false
      if (['completed', 'pending'].includes(this.activity.status)) return true
    }
  },
  methods: {
    statusText: function () {
      const {status, type} = this.activity
      if (status === 'new') return this.activity.type === 'Challenge' ? 'Not yet started' : 'Not yet taken'
      if (status === 'scheduled') return `${this.activity.type} has been scheduled`
      if (type === 'Appointment') {
        let datePresent = this.activity.documents[0]
        return (status === 'completed' && datePresent) ? `Reports Generated on ${moment(this.activity.documents[0].date).format('Do, MMM YYYY')}` : 'Test completed, reports pending'
      }
      if (status === 'overdue') return `${this.activity.type} is overdue`
      if (type === 'HRA') {
        return `Taken on ${moment(this.activity.hra_date).format('Do, MMM YYYY')}`
      }
      if (type === 'Consultation') return this.activity.summary
    },
    toggleView: function () {
      if (['HRA', 'Appointment'].includes(this.activity.type)) {
        this.$emit('toggleView', this.activity.type, this.week)
      }
    }
  }
}
</script>

<style scoped>
  .summary >>> span {
    font-size: 14px !important;
    color: #7c8cab !important;
    line-height: 20px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Customer/HealthCoachProgress.vue